<template>
  <div v-if="!showEditCard" class="card">
    <div class="pageOuterWrap">
      <div class="pageTitleWrap">
        <v-icon name="plus" scale="2.5"></v-icon>
        <!--suppress HtmlFormInputWithoutLabel -->
        <input type="text" placeholder="New event name" v-model="newEventName">
      </div>
      <CreateEvent
        :newEventName="newEventName"
        :numEvents="eventList.length"
        @event-created="updateEventListWithTheNewOne"
      />
    </div>
    <div v-for="(event, key) in eventList" :key="key" class="pageOuterWrap">
      <div class="pageTitleWrap">
        <v-icon name="calendar-alt" scale="2.5"></v-icon>
        <p>{{ event[1] }}</p>
      </div>
      <div class="btnWrap">
        <button-global type="positive" text="EDIT" size="small" @eventPassed="accessSelectedEvent(event)"/>
        <CreateEvent
          action-type="copy"
          :eventId="event[0]" 
          :eventName="event[1]" 
          @event-created="updateEventListWithTheNewOne"
        />
        <RenameEvent 
          :eventId="event[0]" 
          :eventName="event[1]" 
        />
        <DeleteEvent
          :eventId="event[0]"
          :eventName="event[1]"
          @event-deleted="updateEventListWithoutTheDeletedOne"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {app, db} from '@/firebase'
import ButtonGlobal from '@/components/GlobalComponents/ButtonGlobal'
import DeleteEvent from '@/components/EventsPage/DeleteEvent'
import CreateEvent from '@/components/EventsPage/CreateEvent'
import RenameEvent from '@/components/EventsPage/RenameEvent'

export default {
  components: {
    ButtonGlobal,
    DeleteEvent,
    CreateEvent,
    RenameEvent,
  },
  data() {
    return {
      numEvents: 0,
      maxEvents: 0,
      newEventName: '',
      newSiteName: '',
      newEventNo: 0,
      showSuccess: false,
      eventList: [],
      eventTemplate: 'testkunde2_event3',
      showReuseModal: false,
      showEditCard: false
    }
  },
  created() {
    // Get events for active Customer
    db.ref(`/customers/${this.$customerId}/events`)
      .once('value')
      .then(data => {
        let events = [] 
        data.forEach( snapshot => {
          events.push([snapshot.key, snapshot.val()]);
        });

        this.eventList = Object.values(events)
        if (events) {
          // Sort according to event name
          this.eventList.sort(this.sortEvents)
        }
      })
  },
  methods: {
    updateEventListWithTheNewOne(eventID, eventName) {
      this.eventList.push([eventID, eventName])
      this.eventList.sort(this.sortEvents)
      this.newEventName = ''
    },
    updateEventListWithoutTheDeletedOne(eventId) {
      this.eventList = this.eventList.filter(function (eventEntry) {
        return eventEntry[0] !== eventId
      }) // Refreshing displayed list
    },
    sortEvents(a, b) {
      const eventName = 1
      const eventA = a[eventName].toUpperCase()
      const eventB = b[eventName].toUpperCase()

      let comparison = 0
      if (eventA > eventB) {
        comparison = 1
      } else if (eventA < eventB) {
        comparison = -1
      }
      return comparison
    },
    accessSelectedEvent(event) {
      let userId = app.auth().currentUser.uid;
      // backward compatibility until changed.
      let eventName = event[0];
      if (!event[0].includes(this.$customerId)) {
        eventName = this.$customerId + '_' + event[0]
      }
      db.ref('/users/' + userId).update({hotel: eventName}).then(() => {
        this.$hotelId = eventName
        window.location.pathname = `/${eventName}/edit`
      })
    }
  }
}

</script>

<style scoped>

* {
  box-sizing: border-box;
}

.card {
  margin: 10px auto;
  max-width: 1152px;
  display: flex;
  flex-direction: column;
}

.pageOuterWrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 2px 6px rgb(0 0 0 / 20%);
  background-color: #FFFFFF;
  padding: 7px;
  margin: 8px 10px;
  height: 80px;
  border-radius: 8px;
}

.pageTitleWrap {
  display: flex;
  align-items: center;
  margin-left: 10px;
  width: 100%;
}

.pageTitleWrap > img {
  width: 50px;
  height: 50px;
}

.pageTitleWrap > p {
  margin-left: 20px;
}

.pageTitleWrap > input {
  margin-left: 20px;
  width: 100%;
  padding: 10px 15px;
  font-size: 22px;
}

.btnWrap {
  display: flex;
}

.btnWrap > div {
  margin-right: 10px;
}

img {
  opacity: 0.7;
}

@media ( max-width: 760px) {
  .contentCard {
    width: 100%;
    padding-right: 0;
  }

  .pageOuterWrap {
    flex-direction: column;
    height: auto;
  }
}

@media (min-width: 1439px) {
  .contentCard {
    width: 80vw;
  }
}

</style>
